import WithdrawalTable from "./WithdrawalTable";

export default WithdrawalTable;
